import * as React from "react";

const CaretUpDownStrokeRegularIcon = ({ color = "#1f1f1f", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="none"
    {...props}
  >
    <path
      d="M3.75 8.25L6 10.5L8.25 8.25"
      stroke="white"
      style={{
        stroke: "white",
        strokeOpacity: 1
      }}
      strokeWidth={0.75}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.75 8.25L6 10.5L8.25 8.25"
      stroke={color}
      strokeOpacity={0.6}
      style={{
        stroke: { color },
        strokeOpacity: 0.6
      }}
      strokeWidth={0.75}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.75 3.75L6 1.5L8.25 3.75"
      stroke="white"
      style={{
        stroke: "white",
        strokeOpacity: 1
      }}
      strokeWidth={0.75}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.75 3.75L6 1.5L8.25 3.75"
      stroke={color}
      strokeOpacity={0.6}
      style={{
        stroke: { color },
        strokeOpacity: 0.6
      }}
      strokeWidth={0.75}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default CaretUpDownStrokeRegularIcon;
